import { render, staticRenderFns } from "./StockPrint.vue?vue&type=template&id=82563616&scoped=true&"
import script from "./StockPrint.vue?vue&type=script&lang=js&"
export * from "./StockPrint.vue?vue&type=script&lang=js&"
import style0 from "./StockPrint.vue?vue&type=style&index=0&id=82563616&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82563616",
  null
  
)

export default component.exports